<template>
  <div class="sea-index">
    <website-header :setNum="3"></website-header>
    <div class="index-top" :style="`background-image:url('${imgURI + '/static/sea/pinpaichuhaibj.png'}');`">
<!--      <div class="index-top-bor">-->
<!--        <div class="display-flex tips-c">侃侃 让世界更懂你！</div>-->
<!--        <div class="display-flex flex-column tips">-->
<!--          <div class="bold">MAKE THE WORLD</div>-->
<!--          <div class="font-weight-100">UNDERSTAND YOU BETTER</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div id="profile" class="sea-introductory" :style="`background-image:url('${imgURI + '/static/sea/bj1.png'}');`">
      <div class="sea-introductory-content-bor">
        <img :src="`${imgURI}/static/sea/pinpaichuhaijj.png`"/>
        <div class="sea-introductory-content font-14 color-FFFFFF">
          中国传统品牌通过跨境电商出海涉及多个环节，从市场调研到物流配送，每个步<br/>
          骤都是确保品牌成功进入国际市场的重要组成部分。
        </div>
      </div>
    </div>
    <div id="service" class="sea-top-two display-flex justify-content-between def-width margin-center">
      <ul class="sea-ul display-flex flex-wrap">
        <li @click="changeCheck(index)" class="cursor-pointer" :class="{'li-check': seaCheck === index}" v-for="(item, index) in seaList" :key="index">
          <img class="li-img" :src="`${imgURI}/static/sea/${seaCheck === index ? item.checkIcon:item.icon}`"/>
          <img class="li-check-img" :src="`${imgURI}/static/sea/${item.checkIcon}`"/>
          <div>{{item.title}}</div>
        </li>
      </ul>
      <img class="sea-check" :src="`${imgURI}/static/sea/${seaList[seaCheck].checkImg}`">
    </div>
    <div class="def-width margin-center text-center">
      <img :src="`${imgURI}/static/sea/yydt.png`"/>
    </div>
    <div class="force" :style="`background-image:url('${imgURI + '/static/sea/dt.png'}');`">
      <div class="website-index-tips text-center">
        <span class="tips-about bold color-FFFFFF">BRAND FORCE<span class="tips-block"></span></span>
      </div>
      <div class="font-24 color-FFFFFF text-center">侃侃精准把握航线，构建传统企业出海“品牌力”</div>
    </div>
    <div class="msg-bor def-width margin-center">
      <div class="msg-bor-left">
        <div class="title">我们具有专业精英服务团队</div>
        <div class="msg color-979797">
          侃侃精英服务团队深耕跨境电商行业，形成一套完整的集调研、体验、合作、分享为一体的多元化 服务体系，为所有项目客户建立个人信息库，设立专业咨询顾问服务团队，全程跟进客户体验及反馈，第一时间解决客户在运营过程中遇到的问题。
        </div>
      </div>
      <div class="intro-carousel">
        <img :src="`${imgURI}/static/sea/5-1.png`">
      </div>
    </div>
    <div style="clear: both"></div>
    <ul class="sea-list-1 display-flex justify-content-between def-width margin-center text-center">
      <li v-for="(item, index) in seaList1" :key="index">
        <img :src="`${imgURI}/static/sea/${item.icon}`"/>
        <div>{{item.title}}</div>
      </li>
    </ul>
    <div class="msg-bor def-width margin-center">
      <div class="msg-bor-left" style="float: right;">
        <div class="title">品牌出海特色服务</div>
        <div class="msg color-979797">
          全球经济一体化和互联网技术飞速发展的大趋势下，越来越多的品牌意识到跨境电商出海的巨大潜 力。随着消费者对优质、特色产品的需求不断长，以及跨境贸易政策的逐步完善，为品牌拓展海 外市场提供了良好的机遇。侃侃跨境为协助品牌出海提供了全新的特色服务以帮助企业。将品牌 产品推向国际市场，提高品牌知名度和影响力。增加产品销售渠道，实现销售额的快速增长。建立 稳定的海外客户群体，提升客户满意度和忠诚度。
        </div>
      </div>
      <div class="intro-carousel" style="float: left;">
        <img :src="`${imgURI}/static/sea/5-2.png`">
      </div>
    </div>
    <div style="clear: both"></div>
    <ul class="sea-list-1 display-flex justify-content-between def-width margin-center text-center">
      <li v-for="(item, index) in seaList2" :key="index">
        <img :src="`${imgURI}/static/sea/${item.icon}`"/>
        <div>{{item.title}}</div>
      </li>
    </ul>
    <div class="sea-msg font-12 color-979797 text-center">
      在过去的13年里侃侃跨境致力于成为跨境出口电商行业内TOP的企业孵化、培训及服务平台。<br/>
      为所有的跨境电商人打造跨境出口电商行业内规模最大且不断追求价值实现的商业共同体。<br/>
      历经13年的市场检验与沉淀，侃侃跨境助力至少1000家国内传统制造型企业出海，<br/>
      帮助至少1000 家亿级跨境电商企业实现跨越式发展。
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import tips from '@/components/public/tips'
import config from '@/config/index'

export default {
  components: {WebsiteBot, WebsiteHeader, tips},
  name: 'aboutIndex',
  data () {
    return {
      imgURI: config.imgURI,
      seaList: [
        {
          title: '市场调研与定位',
          icon: '11.png',
          checkIcon: '1.png',
          checkImg: 'tu1.png'
        },
        {
          title: '市场调研与定位',
          icon: '22.png',
          checkIcon: '2.png',
          checkImg: 'tu2.png'
        },
        {
          title: '市场调研与定位',
          icon: '33.png',
          checkIcon: '3.png',
          checkImg: 'tu3.png'
        },
        {
          title: '市场调研与定位',
          icon: '44.png',
          checkIcon: '4.png',
          checkImg: 'tu4.png'
        },
        {
          title: '市场调研与定位',
          icon: '55.png',
          checkIcon: '5.png',
          checkImg: 'tu5.png'
        },
        {
          title: '市场调研与定位',
          icon: '66.png',
          checkIcon: '6.png',
          checkImg: 'tu6.png'
        },
        {
          title: '市场调研与定位',
          icon: '77.png',
          checkIcon: '7.png',
          checkImg: 'tu7.png'
        },
        {
          title: '市场调研与定位',
          icon: '88.png',
          checkIcon: '8.png',
          checkImg: 'tu8.png'
        },
        {
          title: '市场调研与定位',
          icon: '99.png',
          checkIcon: '9.png',
          checkImg: 'tu9.png'
        }
      ],
      seaCheck: 0,
      seaList1: [
        {
          title: '1对1专属顾问',
          icon: '3-1.png'
        },
        {
          title: '专业运营团队',
          icon: '3-2.png'
        },
        {
          title: '跨境咨询服务',
          icon: '3-3.png'
        },
        {
          title: '项目入驻陪跑',
          icon: '3-4.png'
        }
      ],
      seaList2: [
        {
          title: '跨境基础培训',
          icon: '4-1.png'
        },
        {
          title: '跨境实战训',
          icon: '4-2.png'
        },
        {
          title: '跨境陪跑服务',
          icon: '4-3.png'
        },
        {
          title: '跨境店铺代运营',
          icon: '4-4.png'
        }
      ]
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.goAnchor(this.$route.query.id)
    }
  },
  watch: {
    // 监听路由对象$route的变化
    '$route': {
      handler: function (to, from) {
        if (to) {
          this.goAnchor(to.query.id)
        }
      },
      deep: true
    }
  },
  beforeDestroy () {
  },
  methods: {
    goAnchor (id) {
      document.querySelector(`#${id}`).scrollIntoView({
        behavior: 'smooth'
      })
    },
    changeCheck (index) {
      this.seaCheck = index
    }
  }
}
</script>

<style lang="scss" scoped>
.sea-index{
  .index-top{
    margin-top: -100px;
    width: 100%;
    min-height: 750px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .index-top-bor{
      padding-top: 180px;
      margin: 0 auto;
      width: 1200px;
    }
    .tips{
      font-size: 25px;
      color: #ffffff;
    }
    .tips-c{
      letter-spacing: 8px;
      font-size: 48px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .sea-introductory{
    background-repeat: no-repeat;
    width: 1200px;
    margin: 150px auto 0 auto;
    height: 502px;
    .sea-introductory-content-bor{
      padding: 50px 44px;
    }
    .sea-introductory-content{
      margin-top: 20px;
      line-height: 24px;
    }
  }
  .sea-top-two{
    margin: 100px auto 105px auto;
    .sea-ul{
      width: 480px;
      gap: 8px;
      li {
        width: 150px;
        height: 150px;
        text-align: center;
        background: #FBFCFE;
        font-size: 16px;
        img{
          margin: 44px auto 6px auto;
          width: 36px;
          height: 32px;
        }
      }
      .li-img{
        display: block;
      }
      .li-check-img{
        display: none;
      }
      li:hover{
        background: #3696E8;
        color: #FFFFFF;

        .li-check-img{
          display: block;
        }

        .li-img{
          display: none;
        }
      }
      .li-check{
        background: #3696E8;
        color: #FFFFFF;
      }
    }

    .sea-check{
      width: 720px;
      height: 469px;
    }
  }
  .force{
    margin: 140px auto 140px auto;
    width: 100%;
    height: 294px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    .website-index-tips{
      padding: 89px 0 0 0;
    }
    .tips-about{
      letter-spacing: 2px;
      font-size: 40px;
    }
    .tips-block{
      position: relative;
      left: 4px;
      margin-left: 6px;
      display: inline-block;
      width: 20px;
      height: 20px;
      background: #FFFFFF;
      border-radius: 2px 2px 2px 2px;
    }
  }
  .msg-bor{
    padding-top: 60px;
    .msg-bor-left{
      .title{
        margin: 50px auto 0 auto;
        font-size: 24px;
        color: #3696E8;
      }
      box-shadow: 0 0 10px #eaeaea;
      float: left;
      padding: 0 80px;
      width: 416px !important;
      height: 307px;
      background: #FFFFFF;
      position: relative;
      z-index: 2;
    }

    .intro-carousel{
      margin-top: -328px;
      width: 715px;
      float: right;
      z-index: 1;
    }

    .msg{
      margin-top: 20px;
      letter-spacing: 0.5px;
      font-size: 12px;
      line-height: 26px;
    }
  }
  .sea-list-1{
    margin: 80px auto 138px auto;
    li {
      width: 284px;
      height: 150px;
      background: #FBFCFE;
      font-size: 16px;
      img{
        margin: 40px auto 6px auto;
      }
    }
  }
  .sea-msg{
    margin-bottom: 180px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sea/index.vue